import { render } from "./SelfCheckout.vue?vue&type=template&id=ccc6e1a6&scoped=true"
import script from "./SelfCheckout.vue?vue&type=script&lang=js"
export * from "./SelfCheckout.vue?vue&type=script&lang=js"

import "./SelfCheckout.vue?vue&type=style&index=0&id=ccc6e1a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc6e1a6"]])

export default __exports__